import { render, staticRenderFns } from "./UnitsTable.vue?vue&type=template&id=7a77e1f3&"
import script from "./UnitsTable.vue?vue&type=script&lang=js&"
export * from "./UnitsTable.vue?vue&type=script&lang=js&"
import style0 from "./UnitsTable.vue?vue&type=style&index=0&id=7a77e1f3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports